import React, { Component } from 'react'
import throttle from 'lodash/throttle'
import { getNewUserGoodList } from '@/apis/share.ts'
import appInstall from '@/utils/appUtils/appInstall'
import { copyText, formatMoney } from '@/utils/index'
import { isDuApp, compareVersion, getAppVersion } from '@/utils/appUtils/getDevice'
import Jockeys from '@/utils/jockey'
import { Toast } from 'antd-mobile'
import { EditConfigType, GlobalConfigType } from '@/typings/types'
import ProductItem from './ProductItem'
// import imgResize from '@/utils/img-resize'
import ProductTitle from '@/common/productTitle'
import styles from '../index.module.less'
import { currencyCodeMap, currencySymbolMap } from '@/constant'

const imgFilter = (value, size) => {
  return `${value}?x-oss-process=image/resize,m_pad,h_${size},w_${size}`
}

const scrollD = 200 // 滚动请求伐值

interface IProductWrapperProps {
  editConfig: EditConfigType
  categoryId: number
  tabItemTitleBg: string
  globalConfig: GlobalConfigType
  pageId: string
  tabBarActiveTextColor: string
  groupName: string
  tabItemTitleLeftBg: string
  tabItemTitleRightBg: string
  titleBgImgType?: number
}

class ProductWrapper extends Component<
  IProductWrapperProps,
  {
    pageSize: number
    page: number
    total: number
    list: any[]
  }
> {
  static config = {
    name: 'poizon-newProductFlow',
  }
  constructor(props) {
    super(props)
    this.state = {
      list: [],
      page: 0, // 数据组从0开始
      pageSize: 18,
      total: 0,
    }
    this.scrollHandler = throttle(this.scrollHandler, 100)
  }
  componentDidMount() {
    this.getGoodList({
      isInit: true,
    })
    this.initPagnationScroll()
  }

  isLoading = false

  initPagnationScroll = () => {
    window.addEventListener('scroll', this.scrollHandler)
  }

  scrollHandler = () => {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    const windowHeight = document.documentElement.clientHeight || document.body.clientHeight
    const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
    if (scrollTop + windowHeight + scrollD >= scrollHeight) {
      this.onEndReached()
    }
  }

  onEndReached = () => {
    this.getGoodList()
  }

  getCurrency = () => {
    const local = this.props.editConfig.local
    return currencySymbolMap[local] || 'HK$'
  }

  getGoodList = async (config: any = {}) => {
    const { isInit } = config
    const { pageSize, page, total } = this.state
    if (!isInit) {
      if (pageSize * page > total) {
        // 数据请求完毕
        return
      }
    }
    if (this.isLoading) {
      return
    }
    this.isLoading = true
    const { categoryId } = this.props
    const { lang, local } = this.props?.editConfig

    try {
      const { status, data } = await getNewUserGoodList(
        {
          countryCode: local,
          language: lang,
          page,
          pageSize,
          level1CategoryId: Number(categoryId),
          currencyCode: currencyCodeMap[local] || 'HKD', // 根据地区传递币种
        },
        { language: lang, countryCode: local }
      )
      if (status === 200) {
        const nextPageList = (data?.productFlowData || [])[0]?.children || []
        this.setState(({ page, list }) => {
          return {
            list: list.concat(nextPageList),
            page: page + 1,
            total: data.total,
          }
        })
        this.isLoading = false
      }
    } catch (error) {
      console.error(error, 'error')
    } finally {
      this.isLoading = false
    }
  }

  handleCover(url) {
    const newUrl = (url += imgFilter('', 200))
    return newUrl
  }

  goDetail = (params, itemNo) => {
    const { spuId } = params
    if (isDuApp() && compareVersion(getAppVersion(), '2.1.5') !== -1) {
      Jockeys.openNativePage('/sell/productDetail', {
        spuId,
      })
      return
    }

    if (isDuApp()) {
      const msg = '貨號已複製，暫僅可在首頁粘貼並搜索。'
      copyText(itemNo)
      Toast.info(msg)
      return
    }

    appInstall('/sell/productDetail', { spuId })
  }

  render() {
    const list = this.state.list
    const {
      globalConfig,
      pageId,
      tabItemTitleBg,
      tabItemTitleLeftBg,
      tabItemTitleRightBg,
      titleBgImgType,
    } = this.props
    return (
      <div className={styles.group}>
        <ProductTitle
          tabItemTitleBg={tabItemTitleBg}
          tabItemTitleLeftBg={tabItemTitleLeftBg}
          tabItemTitleRightBg={tabItemTitleRightBg}
          tabBarActiveTextColor={this.props.tabBarActiveTextColor}
          title={this.props.groupName}
          titleBgImgType={titleBgImgType}
        />
        {/* <div className={styles.title} style={{ color: this.props.tabBarActiveTextColor }}>
          {tabItemTitleBg && (
            <img className={styles['tab-item-title-bg']} data-layzload-src={imgResize(tabItemTitleBg, 200)} alt="" />
          )}
          <span style={{ position: 'relative', zIndex: 2 }}>{this.props.groupName}</span>
        </div> */}
        <div className={styles.desc}>
          {list.map(({ itemNo, cover, spuId, title, price }, index) => (
            <ProductItem
              itemNo={itemNo}
              index={index}
              cover={cover}
              spuId={spuId}
              title={title}
              price={price}
              handleCover={this.handleCover}
              handlePrice={formatMoney}
              getCurrency={this.getCurrency}
              goDetail={this.goDetail}
              globalConfig={globalConfig}
              pageId={pageId}
              key={spuId}
            />
          ))}
        </div>
      </div>
    )
  }
}

export default ProductWrapper
